"use client"

import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../hooks/useAuth"
import { isAdminEmail, checkIsOwner } from "../services/appwriteAuth"

function AuthListener() {
  const navigate = useNavigate()
  const { user } = useAuth()

  useEffect(() => {
    if (!user) return

    const handleRoleNavigation = async () => {
      if (isAdminEmail(user.email)) {
        console.log("Admin user detected, navigating to admin dashboard")
        navigate("/admin")
        return
      }

      const isOwner = await checkIsOwner(user.email)
      if (isOwner) {
        console.log("Owner user detected, navigating to owner page")
        navigate("/owner")
      }
    }

    // Only navigate on fresh login (check if isNewUser)
    if (user.isNewUser) return
    // handleRoleNavigation() — disabled to avoid redirect loops on page load
  }, [user, navigate])

  return null
}

export default AuthListener
